import React, { forwardRef } from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

const View = forwardRef(({ children, translateTitleKey, ...rest }, ref) => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: translateTitleKey });

  return (
    <div ref={ref} {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
});

View.propTypes = {
  children: PropTypes.node,
  translateTitleKey: PropTypes.string.isRequired,
};

View.defaultProps = {
  children: undefined,
};

export default View;
